module.exports = __webpack_public_path__ + "static/media/3.83ac38f2.jpg";